import useBroker from '@/hooks/useBroker';

const ONESURANCE_CONNECTION_KEY = 'onesurance';

export default function useHasOnesuranceConnection() {
  const { connections } = useBroker();

  return Boolean(
    connections?.some(
      (connection) =>
        connection.key === ONESURANCE_CONNECTION_KEY && connection.active,
    ),
  );
}
